<template>
  <v-navigation-drawer
    v-click-outside="clickOutsideOptions"
    :value="value"
    v-bind="$attrs"
    :fixed="fixed"
    :width="width"
    :right="right"
    :temporary="temporary"
    v-on="$listeners"
  >
    <slot />
  </v-navigation-drawer>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CfsDrawer',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
    width: {
      type: [Number, String],
      default: 256,
    },
    right: {
      type: Boolean,
      default: false,
    },
    temporary: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const clickOutsideOptions = {
      closeConditional(event: MouseEvent) {
        if (props.value) {
          const target = event.target as HTMLElement;
          return !target.closest('.toasted');
        }
        return false;
      },
    };
    return { clickOutsideOptions };
  },
});
</script>
